module.exports = __webpack_public_path__ + "img/step2-en.21eda157.webp";